import { render } from "./RecursivePatientDataMenu.vue?vue&type=template&id=73dc622d"
import script from "./RecursivePatientDataMenu.vue?vue&type=script&lang=js"
export * from "./RecursivePatientDataMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__